
import React, { useState, useEffect } from 'react';
import { ArrowUp } from 'lucide-react';
import { useSmoothScroll } from '@/hooks/useSmoothScroll';

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);
  const { scrollToTop } = useSmoothScroll();

  const toggleVisibility = () => {
    // Check window scroll position
    const windowScroll = window.scrollY > 300;
    const windowScrollable = document.documentElement.scrollHeight > window.innerHeight;
    
    // Check scrollable containers with main-content class
    const mainContent = document.querySelector('.main-content');
    const containerScroll = mainContent ? mainContent.scrollTop > 300 : false;
    const containerScrollable = mainContent ? mainContent.scrollHeight > mainContent.clientHeight : false;
    
    // Check article content containers which might have different class
    const articleContent = document.querySelector('.article-content');
    const articleScroll = articleContent ? articleContent.scrollTop > 300 : false;
    const articleScrollable = articleContent ? articleContent.scrollHeight > articleContent.clientHeight : false;
    
    // Set visibility if any of the conditions are met
    setIsVisible(
      (windowScroll && windowScrollable) || 
      (containerScroll && containerScrollable) ||
      (articleScroll && articleScrollable)
    );

    // Removed console log here as per request
  };

  useEffect(() => {
    // Initial check
    toggleVisibility();
    
    // Add scroll listeners to both window and containers
    window.addEventListener('scroll', toggleVisibility, { passive: true });
    
    const mainContent = document.querySelector('.main-content');
    if (mainContent) {
      mainContent.addEventListener('scroll', toggleVisibility, { passive: true });
    }
    
    const articleContent = document.querySelector('.article-content');
    if (articleContent) {
      articleContent.addEventListener('scroll', toggleVisibility, { passive: true });
    }
    
    // Add resize listener
    window.addEventListener('resize', toggleVisibility, { passive: true });
    
    // Setup a periodic check for dynamic content changes
    const intervalCheck = setInterval(toggleVisibility, 1000);
    
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
      window.removeEventListener('resize', toggleVisibility);
      
      if (mainContent) {
        mainContent.removeEventListener('scroll', toggleVisibility);
      }
      
      if (articleContent) {
        articleContent.removeEventListener('scroll', toggleVisibility);
      }
      
      clearInterval(intervalCheck);
    };
  }, []);

  const handleScrollToTop = () => {
    // Check for scrollable containers and scroll them to top if needed
    const mainContent = document.querySelector('.main-content');
    const articleContent = document.querySelector('.article-content');
    
    if (mainContent && mainContent.scrollTop > 0) {
      mainContent.scrollTo({ top: 0, behavior: 'smooth' });
    } else if (articleContent && articleContent.scrollTop > 0) {
      articleContent.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      scrollToTop(undefined, 250);
    }
  };

  return (
    <>
      {isVisible && (
        <button
          onClick={handleScrollToTop}
          className="fixed bottom-6 right-6 z-[9999] p-3 rounded-full bg-cta/90 text-gray-950 shadow-lg hover:bg-cta hover:scale-110 active:scale-95 transition-all duration-150 backdrop-blur-sm"
          aria-label="Scroll to top"
        >
          <ArrowUp className="h-5 w-5" />
        </button>
      )}
    </>
  );
};

export default ScrollToTop;

